import React from "react";
import { usePaletizacionForm } from "../hooks/usePaletizacionForm";
import LoadMask from "Utils/LoadMask/LoadMask";
import { ListadoPallets } from "./ListadoPallets/ListadoPallets";
import { MetricasPaletizacion } from "../../../../components/MetricasPaletizacion/MetricasPaletizacion";
import { pacasCompletasSobrantePorPadre } from "../hooks/useSobranteReclasificacion";

export const PaletizacionForm = ({ idPaletizacion, regresar }) => {
    const {
        siguienteNumeroPallet,
        pallets,
        CrearPallet,
        EliminarPallet,
        ActualizarEstadoConformePallet,
        EnviarABodega,
        reclasificacionRefreshKey,

        metricasPaletizacion,
        cargando,
    } = usePaletizacionForm(idPaletizacion, regresar);

    const sinPaletizar = metricasPaletizacion.sin_paletizar;

    // la reclasificación de pallets pendiente se lee por producto, porque el
    // total general de reclasificación ahora también incluye el sobrante
    const reclasificacionPendiente =
        sinPaletizar &&
        (sinPaletizar.productos || []).some(function (producto) {
            return (
                producto.reclasificacion &&
                Number(producto.reclasificacion.pacas) > 0
            );
        });

    // solo cuenta como sobrante pendiente si algún padre PT alcanza al menos
    // una paca completa; un saldo menor a una paca no se puede paletizar
    const sobrantePendiente =
        sinPaletizar &&
        Object.values(
            pacasCompletasSobrantePorPadre(sinPaletizar.sobrantes),
        ).some(function (pacas) {
            return pacas > 0;
        });

    return (
        <LoadMask loading={cargando} blur>
            <MetricasPaletizacion
                metricasPaletizacion={metricasPaletizacion}
                mode="sin_paletizar"
            />

            <ListadoPallets
                prodSinPaletizar={metricasPaletizacion.sin_paletizar}
                siguienteNumeroPallet={siguienteNumeroPallet}
                pallets={pallets}
                CrearPallet={CrearPallet}
                EliminarPallet={EliminarPallet}
                ActualizarEstadoConformePallet={ActualizarEstadoConformePallet}
                reclasificacionRefreshKey={reclasificacionRefreshKey}
                reclasificacionPendiente={reclasificacionPendiente}
                sobrantePendiente={sobrantePendiente}
            />
            <MetricasPaletizacion
                metricasPaletizacion={metricasPaletizacion}
                mode="paletizado"
            />
            <div className="d-flex justify-content-center mt-3 gap-2rem">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
                <button className="btn btn-primary" onClick={EnviarABodega}>
                    Enviar a bodega
                </button>
            </div>
        </LoadMask>
    );
};
